import { render, staticRenderFns } from "./SunCoatingModule.vue?vue&type=template&id=2d833a40&"
import script from "./SunCoatingModule.vue?vue&type=script&lang=ts&"
export * from "./SunCoatingModule.vue?vue&type=script&lang=ts&"
import style0 from "./SunCoatingModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports